export const TRANSIT_MODES = {
  bus_all_15: "Frequent bus or rail transit",
  bus_all: "Any bus or rail transit",
  rail: "Urban rail",
  intercity: "Intercity rail"
};

export const TRANSIT_MODES_DROPDOWN = Object.keys(TRANSIT_MODES).map((k) => {
  return { value: k, label: TRANSIT_MODES[k] };
});

export const DEMOGRAPHIC_INDICATORS = {
  med_home_value: "Median home value",
  white_shr: "Share of population that is non-Hispanic white",
  med_hh_income: "Median household income",
  med_rent: "Median rent"
};

export const DEMOGRAPHIC_INDICATORS_DROPDOWN = Object.keys(DEMOGRAPHIC_INDICATORS ).map((k) => {
  return { value: k, label: DEMOGRAPHIC_INDICATORS[k] };
});

export const URBANWIDE_LABEL = "Average across the urban area";
